export enum IDurableFunctionRuntimeStatus {
  //
  // Summary:
  //     The status of the orchestration could not be determined.
  Unknown = -1,
  //
  // Summary:
  //     The orchestration is running (it may be actively running or waiting for input).
  Running = 0,
  //
  // Summary:
  //     The orchestration ran to completion.
  Completed = 1,
  //
  // Summary:
  //     The orchestration completed with ContinueAsNew as is in the process of restarting.
  ContinuedAsNew = 2,
  //
  // Summary:
  //     The orchestration failed with an error.
  Failed = 3,
  //
  // Summary:
  //     The orchestration was canceled.
  Canceled = 4,
  //
  // Summary:
  //     The orchestration was terminated via an API call.
  Terminated = 5,
  //
  // Summary:
  //     The orchestration was scheduled but has not yet started.
  Pending = 6
}